import {
    ComponentPropsWithoutRef,
    ForwardedRef,
    PropsWithChildren,
    forwardRef,
    useContext,
} from 'react';
import { Button } from '@givebutter/primitives/button';
import { FilterContext } from 'components/filter/filters-next/FilterContext';
import { ReadableFilterValue } from 'components/filter/filters-next/ReadableFilterValue';
import { useFilter } from 'components/filter/filters-next/useFilter';
import { injectEquals } from 'components/filter/filters-next/util';
import {
    ContentToggleComponent,
    DownstreamFilterTransform,
    FilterValue,
    ReadableFilterComponent,
    UpstreamFilterTransform,
} from 'components/filter/types';
import { identity } from 'lodash';
import { twJoin } from 'tailwind-merge';

interface ToggleProps extends ComponentPropsWithoutRef<'button'> {}

const Toggle: ContentToggleComponent = forwardRef(
    (props: ToggleProps, ref: ForwardedRef<HTMLButtonElement>) => {
        const { children, className = '' } = props;
        const filterContext = useFilter();

        return (
            <Button
                variant="none"
                ref={ref}
                className={className}
                onClick={() => {
                    filterContext.createOrUpdateFilter({ value: true });
                }}
            >
                {children}
            </Button>
        );
    },
);

const Readable: ReadableFilterComponent = () => {
    return <ReadableFilterValue />;
};

const downstream: DownstreamFilterTransform<boolean> = identity;

const upstream: UpstreamFilterTransform<boolean> = (filter: FilterValue) =>
    injectEquals({
        value: filter.value,
    });

const Label = (props: PropsWithChildren) => {
    const { children } = props;
    const { nodeId } = useContext(FilterContext);

    return <span className={twJoin(nodeId && 'text-blue-500')}>{children}</span>;
};

export { Toggle, Readable, downstream, upstream, Label };
